import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminTradePartnersNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('trade-partner');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
